import ActionTypes from '../constants/actionTypes';
import firebase from '../firebase';
import { NotificationManager } from 'react-notifications';

const firestore = firebase.firestore();

export function getAllProjects(userId) {
  return (dispatch) => {
    dispatch(request());
    const projectsRef = firestore.collection('projects').where('userId', '==', userId);
    return projectsRef
      .get()
      .then((data) => {
        let projects = data ? data.docs.map((item) => ({ ...item.data(), id: item.id })) : [];
        return dispatch(success(projects));
      })
      .catch((error) => dispatch(failure(error)));
  };

  function request() {
    return { type: ActionTypes.GET_ALL_PROJECTS.REQUEST };
  }
  function success(projects) {
    return { type: ActionTypes.GET_ALL_PROJECTS.SUCCESS, payload: projects };
  }
  function failure(error) {
    return { type: ActionTypes.GET_ALL_PROJECTS.FAILURE, payload: error };
  }
}

export function getProject(projectId) {
  return (dispatch) => {
    dispatch(request());
    const projectRef = firestore.collection('projects').doc(projectId);

    return projectRef
      .get()
      .then((doc) => {
        if (doc.exists) {
          return dispatch(success(doc.data()));
        } else {
          return dispatch(failure('No such project'));
        }
      })
      .catch((error) => dispatch(failure(error)));
  };

  function request() {
    return { type: ActionTypes.GET_PROJECT.REQUEST };
  }
  function success(project) {
    return { type: ActionTypes.GET_PROJECT.SUCCESS, payload: project };
  }
  function failure(error) {
    return { type: ActionTypes.GET_PROJECT.FAILURE, payload: error };
  }
}

export function selectProject(project) {
  return (dispatch) => {
    dispatch(request());

    return dispatch(success(project));
  };

  function request() {
    return { type: ActionTypes.SELECT_PROJECT.REQUEST };
  }
  function success(project) {
    return { type: ActionTypes.SELECT_PROJECT.SUCCESS, payload: project };
  }
}

export function createProject(project) {
  return (dispatch) => {
    dispatch(request());

    firestore
      .collection('projects')
      .add(project)
      .then((docRef) => {
        return dispatch(success({ ...project, id: docRef.id }));
      })
      .catch((error) => dispatch(failure(error)));
  };

  function request() {
    return { type: ActionTypes.CREATE_PROJECT.REQUEST };
  }
  function success(project) {
    NotificationManager.success('The project has been created successfully', 'Success!');
    return { type: ActionTypes.CREATE_PROJECT.SUCCESS, payload: project };
  }
  function failure(error) {
    NotificationManager.error('Project create failed', 'Failure!');
    return { type: ActionTypes.CREATE_PROJECT.FAILURE, payload: error };
  }
}

export function updateProject(project) {
  return (dispatch) => {
    dispatch(request());

    firestore
      .collection('projects')
      .doc(project.id)
      .set(project)
      .then(() => {
        return dispatch(success(project));
      })
      .catch((error) => dispatch(failure(error)));
  };

  function request() {
    return { type: ActionTypes.UPDATE_PROJECT.REQUEST };
  }
  function success(project) {
    NotificationManager.success('The project has been updated successfully', 'Success!');
    return { type: ActionTypes.UPDATE_PROJECT.SUCCESS, payload: project };
  }
  function failure(error) {
    NotificationManager.error('Project update failed', 'Failure!');
    return { type: ActionTypes.UPDATE_PROJECT.FAILURE, payload: error };
  }
}

export function deleteProject(projectId) {
  return (dispatch) => {
    dispatch(request());

    firestore
      .collection('projects')
      .doc(projectId)
      .delete()
      .then(() => {
        return dispatch(success(projectId));
      })
      .catch((error) => dispatch(failure(error)));
  };

  function request() {
    return { type: ActionTypes.DELETE_PROJECT.REQUEST };
  }
  function success(id) {
    NotificationManager.success('The project has been deleted successfully', 'Success!');
    return { type: ActionTypes.DELETE_PROJECT.SUCCESS, payload: id };
  }
  function failure(error) {
    NotificationManager.error('Project delete failed', 'Failure!');
    return { type: ActionTypes.DELETE_PROJECT.FAILURE, payload: error };
  }
}
